import dayjs from 'dayjs';
import addMonthsToDate from '/shared/functions/addMonthsToDate';

import 'dayjs/locale/en';
import 'dayjs/locale/zh';

interface FormatReportingPeriodOptions {
  locale?: string;
  monthOffset?: number;
  format?: string;
}

export default function formatReportingPeriod(
  startDate: string | number | Date | null | undefined,
  endDate: string | number | Date | null | undefined,
  { locale = 'en', monthOffset = 0, format = 'MMM YYYY' }: FormatReportingPeriodOptions = {},
): string {
  if (!startDate || !endDate) {
    return '';
  }

  const adjustedStart = monthOffset ? addMonthsToDate(startDate, monthOffset) : new Date(startDate);
  const adjustedEnd = monthOffset ? addMonthsToDate(endDate, monthOffset) : new Date(endDate);

  const start = dayjs(adjustedStart).locale(locale).format(format);
  const end = dayjs(adjustedEnd).locale(locale).format(format);

  const period = `${start} to ${end}`;
  if (period.toLowerCase().includes('invalid')) {
    return '';
  }
  return period;
}
